import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { DownloadSimple, Trash } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { DeleteAccountDialog } from './DeleteAccountDialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const DataControls = ({ username, onAccountDeleted }) => {
  const [exporting, setExporting] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      const res = await axios.get(`${API}/users/me/export`, { responseType: 'blob' });
      const match = /filename="([^"]+)"/.exec(res.headers['content-disposition'] || '');
      downloadBlob(res.data, match?.[1] || `dashlink-data-${username}.json`);
      toast.success('Your data export has downloaded');
    } catch {
      toast.error('Could not export your data. Please try again.');
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="space-y-3" data-testid="data-controls-section">
      <h3 className="text-sm font-medium text-[#71717A] uppercase tracking-wider">Your Data</h3>
      <div className="flex flex-wrap gap-3">
        <Button variant="outline" onClick={handleExport} disabled={exporting} className="border-[#E4E4E7]" data-testid="export-data-button">
          <DownloadSimple size={16} className="mr-2" />
          {exporting ? 'Preparing...' : 'Export My Data'}
        </Button>
        <Button variant="outline" onClick={() => setDeleteOpen(true)} className="border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700" data-testid="delete-account-button">
          <Trash size={16} className="mr-2" />
          Delete My Account
        </Button>
      </div>
      <p className="text-xs text-[#71717A]">Export downloads your profile, stats and chat history as a JSON file.</p>
      <DeleteAccountDialog open={deleteOpen} onOpenChange={setDeleteOpen} onDeleted={onAccountDeleted} />
    </div>
  );
};
